import React from 'react';
import './style.scss';
import OrderStatusSchedulerContainer from "../../../../Redux/containers/OrderStatusSchedulerContainer";
import OrderStatusSwitcherContainer from "../../../../Redux/containers/OrderStatusSwitcherContainer";
import OrderRedirectContainer from "../../../../Redux/containers/OrderRedirectContainer";

const STATUSES_TO_SHOW = ["ACCEPTED", "READY", "SCHEDULED_READY", "ASSIGNED_SCHEDULED_READY", "DELIVERED"];

export default function OrderStatus(props) {
    const orderStatus = props.orders ? props.orders[0].status : props.order.status;

    if (!STATUSES_TO_SHOW.includes(orderStatus))
        return null;

    let statusComponent;

    if (props.isAutopilot) {
        statusComponent = (
            <OrderStatusSchedulerContainer {...props}/>
        );
    } else if (props.isRedirect) {
        statusComponent = (
            <OrderRedirectContainer {...props}/>
        );
    } else {
        statusComponent = (
            <OrderStatusSwitcherContainer {...props}/>
        );
    }

    return (
        <span className="order-status">
            {statusComponent}
        </span>
    );
}
